import type { WeeklyPlanVsFactRow } from '@/hooks/useWeeklyPlanVsFact'

export const WEEKLY_PLAN_FIELDS: Array<keyof WeeklyPlanVsFactRow> = [
  'weekly_leads_plan',
  'weekly_appointments_plan',
  'weekly_new_visitors_plan',
  'weekly_new_sales_plan',
  'weekly_new_sales_amount_plan',
  'weekly_renewals_count_plan',
  'weekly_renewals_amount_plan',
  'weekly_upgrades_count_plan',
  'weekly_upgrades_amount_plan',
  'weekly_returning_clients_count_plan',
  'weekly_returning_clients_amount_plan',
  'weekly_private_sessions_count_plan',
  'weekly_private_sessions_amount_plan',
  'weekly_membership_fees_new_plan',
  'weekly_membership_fees_subscription_upgrades_plan',
  'weekly_membership_fees_subscription_returning_plan',
  'weekly_new_subscriptions_count_plan',
  'weekly_new_subscriptions_amount_plan',
  'weekly_subscription_renewals_count_plan',
  'weekly_subscription_renewals_amount_plan',
  'weekly_subscription_upgrades_count_plan',
  'weekly_subscription_upgrades_amount_plan',
  'weekly_subscription_returning_clients_count_plan',
  'weekly_subscription_returning_clients_amount_plan',
  'weekly_gross_revenue_plan',
  'weekly_marketing_budget_plan',
  'weekly_refunds_amount_plan'
]

export function hasAnyPlanValues(week: WeeklyPlanVsFactRow): boolean {
  return WEEKLY_PLAN_FIELDS.some((field) => week[field] !== null && week[field] !== undefined)
}
